/**
 * Lucy AI Virtual Try-On — Immersive Experience
 * WowStore.live
 *
 * Flow: Product card "Try On" -> Select avatar/upload photo/camera ->
 *       AI generates composite (Fal.ai VTON) -> Result with Add to Cart + Video
 *
 * Backend: creative-studio /tryon/generate on VPS
 * Models: FASHN v1.6 quality mode (primary) -> IDM-VTON (fallback)
 */
(function() {
  'use strict';

  // Prevent double-init
  if (window._lucyTryOnInit) return;
  window._lucyTryOnInit = true;

  // Product types where Try-On is NOT supported (David May 13 directive).
  // Seedream-4.5 flow composites the dominant garment from product photo
  // onto the avatar — meaningless / misleading for non-apparel. Until a
  // category-aware Try-On flow lands (Day-50+), hide the button on these.
  var TRYON_ACCESSORY_DENYLIST = {
    'fashion earrings':1,'earrings':1,'necklace':1,'bracelet':1,'ring':1,'pendant':1,'jewelry':1,
    'bag':1,'handbag':1,'tote bag':1,'backpack':1,
    'hat':1,'cap':1,'beanie':1,'belt':1,'watch':1,
    'sunglasses':1,'glasses':1,'eyewear':1,
    'scarf':1,'bandana':1,'accessory':1,
    'phone case':1,'mug':1,'bottle':1
  };
  function getCurrentProductType() {
    var t = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.type) || '';
    if (!t) {
      var el = document.querySelector('[data-product-type]');
      if (el) t = el.getAttribute('data-product-type') || '';
    }
    return (t || '').toLowerCase().trim();
  }
  function isAccessoryProductType(t) {
    return !!TRYON_ACCESSORY_DENYLIST[(t || '').toLowerCase().trim()];
  }
  window._lucyTryOn_isAccessory = isAccessoryProductType; // debug hook

  // Kids gate (kids plan §4.3, David decision 3 — 17 Oct 2026): no Dressing Room /
  // Magic Mirror on children's products, because children's photos must never be
  // uploaded. Signals: type/title words, tag `kids`, metafield wow.audience=kids
  // (read only if the theme exposes it via [data-wow-audience] or window.__wowAudience).
  // Singular "kid" and "baby blue/pink/tee/doll/alpaca" are skipped (adult fashion terms).
  var KIDS_RX = /\b(kids|kid['\u2019]s|child|children|childrens|toddlers?|infants?|babies)\b|\bbaby\b(?![\s-]*(blue|pink|tee|doll|alpaca|powder))/i;
  function isKidsProduct(product) {
    var parts = [];
    try {
      if (product) parts.push(product.type || '', product.title || '');
      if ((window.location.pathname || '').indexOf('/products/') === 0) {
        parts.push(getCurrentProductType());
        var og = document.querySelector('meta[property="og:title"]');
        if (og) parts.push(og.content || '');
        var h1 = document.querySelector('h1');
        if (h1) parts.push(h1.textContent || '');
        var tagEls = document.querySelectorAll('[data-product-tags]');
        for (var i = 0; i < tagEls.length; i++) {
          var tags = (tagEls[i].getAttribute('data-product-tags') || '').toLowerCase().split(',');
          for (var j = 0; j < tags.length; j++) { if (tags[j].trim() === 'kids') return true; }
        }
        var aud = window.__wowAudience || '';
        var audEl = document.querySelector('[data-wow-audience]');
        if (!aud && audEl) aud = audEl.getAttribute('data-wow-audience') || '';
        if (('' + aud).toLowerCase().trim() === 'kids') return true;
      }
    } catch (e) {}
    return KIDS_RX.test(parts.join(' '));
  }
  window._lucyTryOn_isKids = isKidsProduct; // debug hook

  // ==========================================
  // GENDER-AWARE AVATARS (Magic Mirror v2 — Task 1.1)
  // Store is currently women's-only, so DEFAULT is 'female'.
  // Only return 'male'/'kids' on a clear, word-boundary signal.
  // ==========================================
  function detectContextGender() {
    // 1) Explicit override wins.
    try {
      var g = (window.__mmGender || '').toString().toLowerCase().trim();
      if (g === 'male' || g === 'female' || g === 'kids') return g;
    } catch (e) {}

    // 2) Gather signal text: URL path + product type/vendor + tags + breadcrumb.
    var parts = [];
    try { parts.push((window.location.pathname || '').toLowerCase()); } catch (e) {}
    try {
      var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      if (m) {
        if (m.type) parts.push(('' + m.type).toLowerCase());
        if (m.vendor) parts.push(('' + m.vendor).toLowerCase());
      }
    } catch (e) {}
    try {
      var tagEls = document.querySelectorAll('[data-product-tags]');
      for (var i = 0; i < tagEls.length; i++) {
        parts.push((tagEls[i].getAttribute('data-product-tags') || '').toLowerCase());
      }
    } catch (e) {}
    try {
      var crumb = document.querySelector('.breadcrumb, .breadcrumbs, [class*="breadcrumb"]');
      if (crumb) parts.push((crumb.textContent || '').toLowerCase());
    } catch (e) {}
    var hay = ' ' + parts.join(' ') + ' ';

    // 3) Kids first (most specific), then men, then default female.
    //    Word-boundary-ish: bounded by non-word chars so "women" never matches "men".
    if (/(?:^|[^a-z])(kids|kid|boys|boy|girls|girl|children|child|toddler|baby)(?:[^a-z]|$)/.test(hay)) return 'kids';
    if (/(?:^|[^a-z])(men|mens|man|male)(?:[^a-z]|$)/.test(hay)) return 'male';
    return 'female';
  }
  window._lucyTryOn_detectGender = detectContextGender; // debug hook

  // ==========================================
  // CONFIG
  // ==========================================
  var TRYON_API = 'https://n8n.wowstore.live/tryon';
  var POLL_INTERVAL = 3000;
  var MAX_POLL_TIME = 120000;
  var MAX_FILE_SIZE = 10 * 1024 * 1024;

  // Feature flag config — fetched from backend /tryon/config once on load.
  // Until the backend confirms tryon_enabled=true, the customer-facing entry
  // points (product-page button, panel open) are no-ops. Lets David flip on
  // the live experience from one env var on the server (TRYON_ENABLED=true).
  var TRYON_CONFIG = {
    tryon_enabled: false,
    model_display: 'Seedream 4.5',
    daily_free_limit: 500,
    loaded: false
  };

  // viewer_session_id — cookie-bound, used to join try-on -> Shopify cart -> order.
  function getViewerSessionId() {
    try {
      var m = document.cookie.match(/(?:^|; )wow_vsid=([^;]+)/);
      if (m) return decodeURIComponent(m[1]);
      var rnd = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID()
               : 'vs-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);
      // 30-day cookie (conversion window: 7d; cookie longer for safety)
      document.cookie = 'wow_vsid=' + encodeURIComponent(rnd) + '; Max-Age=' + (60*60*24*30) + '; Path=/; SameSite=Lax';
      return rnd;
    } catch (e) { return 'vs-anon-' + Date.now(); }
  }
  var VIEWER_SESSION_ID = getViewerSessionId();

  // Full-body avatar models for VTON (diverse, fashion-ready)
  // WowStore AI Influencer Fleet — consistent brand faces across all touchpoints
  // Brand internationally, promote locality (MTV/Andaz strategy)
  // Front body shots from 360° fleet — perfect for VTON: full body, clean BG
  /* 27 Oct 2026: on the R2 avatars/ prefix the Mirror safety rules accept as our AI avatars (ai-fleet/ was refused) */
  var FLEET_BASE = 'https://pub-09283f14200e4ea1be6001f3249686f4.r2.dev/avatars/fleet/';
  var AVATARS = [
    // === Brand Face & Core Team (familiarity-first — always show first) ===
    { id: 'lucy',   label: 'Lucy',    gender: 'female', url: FLEET_BASE + 'lucy_front.png',   body: 'slim',     role: 'brand-face' },
    { id: 'sofia',  label: 'Sofia',   gender: 'female', url: FLEET_BASE + 'sofia_front.png',  body: 'slim',     role: 'wisdom' },
    { id: 'wow',    label: 'Wow',     gender: 'female', url: FLEET_BASE + 'wow_front.png',    body: 'slim',     role: 'bestie' },
    // === Style Squad — diverse representation ===
    { id: 'max',    label: 'Max',     gender: 'male',   url: FLEET_BASE + 'max_front.png',    body: 'athletic', role: 'street' },
    { id: 'amara',  label: 'Amara',   gender: 'female', url: FLEET_BASE + 'amara_front.png',  body: 'slim',     role: 'global' },
    { id: 'emma',   label: 'Emma',    gender: 'female', url: FLEET_BASE + 'emma_front.png',   body: 'slim',     role: 'eco' },
    { id: 'nico',   label: 'Nico',    gender: 'male',   url: FLEET_BASE + 'nico_front.png',   body: 'average',  role: 'tech' },
    // === The Original Five — EU expat diversity ===
    { id: 'clara',  label: 'Clara',   gender: 'female', url: FLEET_BASE + 'clara_front.png',  body: 'slim',     role: 'expat-fr' },
    { id: 'julian', label: 'Julian',  gender: 'male',   url: FLEET_BASE + 'julian_front.png', body: 'average',  role: 'tech-nl' },
    { id: 'maya',   label: 'Maya',    gender: 'female', url: FLEET_BASE + 'maya_front.png',   body: 'slim',     role: 'wellness' },
    { id: 'leo',    label: 'Leo',     gender: 'male',   url: FLEET_BASE + 'leo_front.png',    body: 'athletic', role: 'trendsetter' },
    { id: 'sophie', label: 'Sophie',  gender: 'female', url: FLEET_BASE + 'sophie_front.png', body: 'slim',     role: 'creative' },
    // 27 Oct 2026: Lilith retired from the cast (David 25 Oct)
    // === Plus-size & inclusive (KEEP — body diversity matters) ===
    { id: 'f5',     label: 'Jasmine', gender: 'female', url: 'https://n8n.wowstore.live/tryon/cached/avatar_f5.jpg', body: 'curvy',  role: 'inclusive' },
    { id: 'f6',     label: 'Rosa',    gender: 'female', url: 'https://n8n.wowstore.live/tryon/cached/avatar_f6.jpg', body: 'plus',   role: 'inclusive' },
    { id: 'm5',     label: 'Andre',   gender: 'male',   url: 'https://n8n.wowstore.live/tryon/cached/avatar_m5.jpg', body: 'large',  role: 'inclusive' }
  ];

  // ==========================================
  // STATE
  // ==========================================
  var state = {
    isOpen: false,
    product: null,
    personImage: null,
    personSource: null,
    selectedAvatar: null,
    jobId: null,
    resultImage: null,
    isGenerating: false,
    activeTab: 'avatars'
  };

  // ==========================================
  // SAFE DOM HELPERS
  // ==========================================
  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function(k) {
        if (k === 'className') node.className = attrs[k];
        else if (k === 'textContent') node.textContent = attrs[k];
        else if (k.indexOf('on') === 0) node.addEventListener(k.slice(2).toLowerCase(), attrs[k]);
        else node.setAttribute(k, attrs[k]);
      });
    }
    if (children) {
      children.forEach(function(c) {
        if (typeof c === 'string') node.appendChild(document.createTextNode(c));
        else if (c) node.appendChild(c);
      });
    }
    return node;
  }

  // ==========================================
  // CREATE DOM (safe — no innerHTML)
  // ==========================================
  function createTryOnPanel() {
    var panel = el('div', { id: 'lucyTryOn', className: 'lto-panel' });

    // Header
    var header = el('div', { className: 'lto-header' }, [
      el('button', { className: 'lto-back', id: 'ltoBack', textContent: '\u2190' }),
      el('span', { className: 'lto-title', textContent: 'Your Dressing Room' }),
      el('span', { className: 'lto-badge', textContent: 'Magic Mirror' })
    ]);
    panel.appendChild(header);

    // Product bar
    var productBar = el('div', { className: 'lto-product', id: 'ltoProduct' }, [
      el('img', { className: 'lto-product-img', id: 'ltoProductImg', src: '', alt: '' }),
      el('div', { className: 'lto-product-info' }, [
        el('div', { className: 'lto-product-name', id: 'ltoProductName' }),
        el('div', { className: 'lto-product-price', id: 'ltoProductPrice' })
      ])
    ]);
    panel.appendChild(productBar);

    // Tabs
    var tabsDiv = el('div', { className: 'lto-tabs' }, [
      el('button', { className: 'lto-tab active', 'data-tab': 'avatars', textContent: '\uD83D\uDC64 Select Model' }),
      el('button', { className: 'lto-tab', 'data-tab': 'upload', textContent: '\uD83D\uDCF8 Your Photo' })
    ]);
    panel.appendChild(tabsDiv);

    // Avatar content
    var avatarContent = el('div', { className: 'lto-content active', id: 'ltoAvatars' });
    var avatarGrid = el('div', { className: 'lto-avatar-grid', id: 'ltoAvatarGrid' });
    // Magic Mirror v2 (Task 1.1): show only gender-matching models, capped at 8.
    // 'kids' has no fleet yet -> fall back to the female set. Array order is
    // already Lucy/Sofia/Wow first, so the first 8 are the priority models.
    var _ctxGender = detectContextGender();
    if (_ctxGender === 'kids') _ctxGender = 'female';
    var _visibleAvatars = AVATARS.filter(function(a) { return a.gender === _ctxGender; });
    if (!_visibleAvatars.length) _visibleAvatars = AVATARS.filter(function(a) { return a.gender === 'female'; });
    _visibleAvatars = _visibleAvatars.slice(0, 8);
    _visibleAvatars.forEach(function(av) {
      var avatarEl = el('div', { className: 'lto-avatar', 'data-avatar': av.id, 'data-url': av.url }, [
        el('img', { src: av.url, alt: av.label, loading: 'lazy' }),
        el('span', { className: 'lto-avatar-name', textContent: av.label }),
        el('span', { className: 'lto-avatar-check', textContent: '\u2713' })
      ]);
      avatarGrid.appendChild(avatarEl);
    });
    avatarContent.appendChild(avatarGrid);
    panel.appendChild(avatarContent);

    // Upload content
    var uploadContent = el('div', { className: 'lto-content', id: 'ltoUpload' });
    var uploadZone = el('div', { className: 'lto-upload-zone', id: 'ltoUploadZone' }, [
      el('div', { className: 'lto-upload-icon', textContent: '\uD83D\uDCF7' }),
      el('div', { className: 'lto-upload-text', textContent: 'Tap to upload your photo' }),
      el('div', { className: 'lto-upload-hint', textContent: 'Full body or upper body works best' })
    ]);
    var privacyNote = el('div', { className: 'lto-privacy-note', id: 'ltoPrivacyNote' }, [
      el('span', { className: 'lto-privacy-icon', textContent: '\uD83D\uDD12 ' }),
      el('span', { textContent: 'Your photo is private. Used only for this Magic Mirror look. Not stored permanently.' })
    ]);
    var fileInput = el('input', { type: 'file', id: 'ltoFileInput', accept: 'image/*', style: 'display:none' });
    uploadZone.appendChild(fileInput);
    uploadContent.appendChild(uploadZone);

    var uploadPreview = el('div', { className: 'lto-upload-preview', id: 'ltoUploadPreview', style: 'display:none' }, [
      el('img', { id: 'ltoUploadedImg', src: '', alt: 'Your photo' }),
      el('button', { className: 'lto-remove-photo', id: 'ltoRemovePhoto', textContent: '\u00D7 Remove' })
    ]);
    uploadContent.appendChild(uploadPreview);

    var cameraBtn = el('button', { className: 'lto-camera-btn', id: 'ltoCameraBtn', textContent: '\uD83D\uDCF7 Take a Selfie' });
    uploadContent.appendChild(cameraBtn);
    uploadContent.appendChild(privacyNote);
    // AI Act W1b (25 Oct 2026): own photo only, 18+. The server checks consent_self (ai_safety 'consent').
    var consentRow = el('label', { className: 'lto-consent', id: 'ltoConsent', for: 'ltoConsentBox',
      style: 'display:flex;gap:8px;align-items:flex-start;font-size:12px;line-height:1.4;margin-top:10px;cursor:pointer' }, [
      el('input', { type: 'checkbox', id: 'ltoConsentBox', style: 'margin-top:2px' }),
      el('span', { textContent: "This is a photo of me, I'm 18 or older, and I agree to the Magic Mirror rules." })
    ]);
    uploadContent.appendChild(consentRow);
    panel.appendChild(uploadContent);

    // Generate button wrap
    var genWrap = el('div', { className: 'lto-generate-wrap', id: 'ltoGenerateWrap' });
    var genBtn = el('button', { className: 'lto-generate-btn', id: 'ltoGenerateBtn', disabled: 'disabled' }, [
      el('span', { className: 'lto-gen-text', textContent: '\u2728 Show me in the Magic Mirror' }),
      el('span', { className: 'lto-gen-loader', style: 'display:none' })
    ]);
    genWrap.appendChild(genBtn);
    genWrap.appendChild(el('div', { className: 'lto-gen-hint', id: 'ltoGenHint', textContent: 'Select a model or upload your photo first' }));
    panel.appendChild(genWrap);

    // Result section
    var resultSection = el('div', { className: 'lto-result', id: 'ltoResult', style: 'display:none' });

    // Side-by-side comparison panel (Reference | Try-On)
    var compareWrap = el('div', { className: 'lto-compare', id: 'ltoCompare' });
    var compareLeft = el('div', { className: 'lto-compare-side lto-compare-left' }, [
      el('div', { className: 'lto-compare-label', textContent: 'Product' }),
      el('img', { className: 'lto-compare-img', id: 'ltoCompareLeftImg', src: '', alt: 'Product reference' })
    ]);
    var compareSwap = el('button', { className: 'lto-compare-swap', id: 'ltoCompareSwap',
      title: 'Swap', textContent: '⇄' });
    var compareRight = el('div', { className: 'lto-compare-side lto-compare-right' }, [
      el('div', { className: 'lto-compare-label', textContent: 'On You' }),
      el('img', { className: 'lto-compare-img', id: 'ltoCompareRightImg', src: '', alt: 'You in the Magic Mirror' })
    ]);
    compareWrap.appendChild(compareLeft);
    compareWrap.appendChild(compareSwap);
    compareWrap.appendChild(compareRight);
    resultSection.appendChild(compareWrap);
    // 24 Oct 2026 (David): the old "These match the actual product 1:1" claim was often untrue
    // (3 of 11 renders were 1:1) -> honest line + one-click "Does it match?" feedback (mountMatchFeedback).
    var trustNote = el('div', { className: 'lto-trust-note lto-match', id: 'ltoTrustNote', role: 'group', 'aria-label': MFB_T.group });
    resultSection.appendChild(trustNote);

    var resultImgWrap = el('div', { className: 'lto-result-img-wrap', style: 'display:none' }, [
      el('img', { className: 'lto-result-img', id: 'ltoResultImg', src: '', alt: 'You in the Magic Mirror' })
    ]);
    resultSection.appendChild(resultImgWrap);

    // Model chip — transparency + reinforce value
    var modelChip = el('div', { className: 'lto-model-chip', id: 'ltoModelChip', textContent: '' });
    resultSection.appendChild(modelChip);

    var actionsRow1 = el('div', { className: 'lto-result-actions' }, [
      el('button', { className: 'lto-action-btn lto-cart-btn', id: 'ltoAddToCart', textContent: '\uD83D\uDED2 Add to Cart' }),
      el('button', { className: 'lto-action-btn lto-video-btn', id: 'ltoMakeVideo', textContent: '\uD83C\uDFAC Make Video' })
    ]);
    resultSection.appendChild(actionsRow1);

    var actionsRow360 = el('div', { className: 'lto-result-actions' }, [
      el('button', { className: 'lto-action-btn lto-360-btn', id: 'lto360View', style: 'display:none', textContent: '\uD83D\uDD04 360\u00B0 View' })
    ]);
    resultSection.appendChild(actionsRow360);

    // 360° 3D Model Viewer container (hidden by default)
    var spinViewer = el('div', { className: 'lto-spin-viewer', id: 'ltoSpinViewer', style: 'display:none' });
    var spinTitle = el('div', { className: 'lto-spin-title' }, [
      el('span', { textContent: '\uD83D\uDD04 360\u00B0 3D Product View' }),
      el('button', { className: 'lto-spin-close', id: 'ltoSpinClose', textContent: '\u2715' })
    ]);
    spinViewer.appendChild(spinTitle);
    var spinCanvas = el('div', { className: 'lto-spin-canvas', id: 'ltoSpinCanvas' });
    spinViewer.appendChild(spinCanvas);
    var spinStatus = el('div', { className: 'lto-spin-status', id: 'ltoSpinStatus', style: 'display:none' });
    spinViewer.appendChild(spinStatus);
    var spinHint = el('div', { className: 'lto-spin-hint', textContent: 'Drag to rotate \u00B7 Scroll to zoom' });
    spinViewer.appendChild(spinHint);
    resultSection.appendChild(spinViewer);

    var actionsRow2 = el('div', { className: 'lto-result-actions lto-result-row2' }, [
      el('button', { className: 'lto-action-btn lto-retry-btn', id: 'ltoRetry', textContent: '\uD83D\uDD04 Try Another Look' }),
      el('button', { className: 'lto-action-btn lto-share-btn', id: 'ltoShare', textContent: '\uD83D\uDCE4 Share' })
    ]);
    resultSection.appendChild(actionsRow2);
    panel.appendChild(resultSection);

    // Progress overlay
    var progress = el('div', { className: 'lto-progress', id: 'ltoProgress', style: 'display:none' });
    var progressInner = el('div', { className: 'lto-progress-inner' }, [
      el('div', { className: 'lto-spinner' }),
      el('div', { className: 'lto-progress-text', id: 'ltoProgressText', textContent: 'Lucy is dressing you up...' }),
      el('div', { className: 'lto-progress-sub', id: 'ltoProgressSub', textContent: 'This takes about 15-30 seconds' })
    ]);
    progress.appendChild(progressInner);
    panel.appendChild(progress);

    document.body.appendChild(panel);

    // Inject CSS
    injectStyles();
    // Bind events
    bindEvents();
  }

  // ==========================================
  // STYLES
  // ==========================================
  function injectStyles() {
    if (document.getElementById('lucyTryOnCSS')) return;
    var style = document.createElement('style');
    style.id = 'lucyTryOnCSS';
    style.textContent = [
      '.lto-panel { position:fixed; bottom:0; right:16px; width:380px; max-width:calc(100vw - 32px); height:calc(100vh - 80px); max-height:680px; background:#fff; border-radius:20px 20px 0 0; box-shadow:0 -8px 40px rgba(0,0,0,0.18); z-index:100001; display:none; flex-direction:column; overflow:hidden; font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif; }',
      '.lto-panel.active { display:flex; animation:ltoSlideUp .35s ease; }',
      '.lto-panel.lto-in-chat { position:absolute; top:0; right:0; bottom:0; left:0; width:auto; height:auto; max-width:none; max-height:none; border-radius:inherit; box-shadow:none; z-index:30; transform:none; animation:none; }',
      '@keyframes ltoSlideUp { from{transform:translateY(100%);opacity:0} to{transform:translateY(0);opacity:1} }',
      '.lto-header { display:flex; align-items:center; gap:10px; padding:14px 16px; background:linear-gradient(135deg,#ec4899,#8b5cf6); color:#fff; flex-shrink:0; }',
      '.lto-back { background:none; border:none; color:#fff; font-size:20px; cursor:pointer; padding:4px 8px; border-radius:8px; }',
      '.lto-back:hover { background:rgba(255,255,255,0.2); }',
      '.lto-title { flex:1; font-size:16px; font-weight:700; }',
      '.lto-badge { background:rgba(255,255,255,0.25); padding:2px 10px; border-radius:12px; font-size:11px; font-weight:700; letter-spacing:1px; }',
      '.lto-product { display:flex; align-items:center; gap:12px; padding:10px 16px; border-bottom:1px solid #f1f1f1; flex-shrink:0; }',
      '.lto-product-img { width:48px; height:48px; border-radius:10px; object-fit:cover; border:2px solid #f3e8ff; }',
      '.lto-product-name { font-size:13px; font-weight:600; color:#1f2937; line-height:1.3; max-height:2.6em; overflow:hidden; }',
      '.lto-product-price { font-size:14px; font-weight:700; color:#ec4899; margin-top:2px; }',
      '.lto-tabs { display:flex; border-bottom:2px solid #f3f4f6; flex-shrink:0; }',
      '.lto-tab { flex:1; padding:10px 0; background:none; border:none; font-size:13px; font-weight:600; color:#9ca3af; cursor:pointer; transition:all .2s; border-bottom:2px solid transparent; margin-bottom:-2px; }',
      '.lto-tab:hover { color:#6b7280; }',
      '.lto-tab.active { color:#8b5cf6; border-bottom-color:#8b5cf6; }',
      '.lto-content { display:none; overflow-y:auto; flex:1; padding:12px 16px; }',
      '.lto-content.active { display:block; }',
      '.lto-avatar-grid { display:grid; grid-template-columns:repeat(4,1fr); gap:8px; }',
      '.lto-avatar { position:relative; border-radius:12px; overflow:hidden; cursor:pointer; border:3px solid transparent; transition:all .2s; aspect-ratio:3/4; }',
      '.lto-avatar:hover { border-color:#e9d5ff; transform:scale(1.03); }',
      '.lto-avatar.selected { border-color:#8b5cf6; box-shadow:0 0 0 2px #c4b5fd; }',
      '.lto-avatar img { width:100%; height:100%; object-fit:cover; }',
      '.lto-avatar-name { position:absolute; bottom:0; left:0; right:0; padding:3px 0; background:linear-gradient(transparent,rgba(0,0,0,0.7)); color:#fff; text-align:center; font-size:10px; font-weight:600; }',
      '.lto-avatar-check { position:absolute; top:4px; right:4px; width:20px; height:20px; background:#8b5cf6; color:#fff; border-radius:50%; display:none; align-items:center; justify-content:center; font-size:12px; font-weight:700; }',
      '.lto-avatar.selected .lto-avatar-check { display:flex; }',
      '.lto-upload-zone { border:2px dashed #d1d5db; border-radius:16px; padding:28px 20px; text-align:center; cursor:pointer; transition:all .2s; margin-bottom:12px; }',
      '.lto-upload-zone:hover { border-color:#8b5cf6; background:#faf5ff; }',
      '.lto-upload-icon { font-size:36px; margin-bottom:8px; }',
      '.lto-upload-text { font-size:14px; font-weight:600; color:#374151; }',
      '.lto-upload-hint { font-size:11px; color:#9ca3af; margin-top:4px; }',
      '.lto-upload-preview { position:relative; border-radius:16px; overflow:hidden; margin-bottom:12px; }',
      '.lto-upload-preview img { width:100%; max-height:300px; object-fit:cover; border-radius:16px; }',
      '.lto-remove-photo { position:absolute; top:8px; right:8px; background:rgba(0,0,0,0.6); color:#fff; border:none; padding:4px 12px; border-radius:20px; cursor:pointer; font-size:12px; }',
      '.lto-camera-btn { width:100%; padding:12px; background:linear-gradient(135deg,#3b82f6,#6366f1); color:#fff; border:none; border-radius:12px; font-size:14px; font-weight:600; cursor:pointer; transition:all .2s; }',
      '.lto-camera-btn:hover { transform:translateY(-1px); box-shadow:0 4px 12px rgba(99,102,241,0.4); }',
      '.lto-generate-wrap { padding:12px 16px; border-top:1px solid #f3f4f6; flex-shrink:0; }',
      '.lto-generate-btn { width:100%; padding:14px; background:linear-gradient(135deg,#ec4899,#8b5cf6); color:#fff; border:none; border-radius:14px; font-size:15px; font-weight:700; cursor:pointer; transition:all .3s; display:flex; align-items:center; justify-content:center; gap:8px; }',
      '.lto-generate-btn:disabled { opacity:0.5; cursor:not-allowed; transform:none; }',
      '.lto-generate-btn:not(:disabled):hover { transform:translateY(-2px); box-shadow:0 6px 20px rgba(236,72,153,0.4); }',
      '.lto-gen-hint { font-size:11px; color:#9ca3af; text-align:center; margin-top:6px; }',
      '.lto-gen-loader { width:18px; height:18px; border:2px solid rgba(255,255,255,0.3); border-top-color:#fff; border-radius:50%; animation:ltoSpin 0.8s linear infinite; display:inline-block; }',
      '@keyframes ltoSpin { to{transform:rotate(360deg)} }',
      '.lto-result { flex:1; overflow-y:auto; padding:16px; }',
      '.lto-result-img-wrap { border-radius:16px; overflow:hidden; box-shadow:0 4px 20px rgba(0,0,0,0.12); margin-bottom:14px; }',
      '.lto-result-img { width:100%; display:block; }',
      '.lto-result-actions { display:flex; gap:8px; margin-bottom:8px; }',
      '.lto-action-btn { flex:1; padding:11px 8px; border:none; border-radius:12px; font-size:13px; font-weight:600; cursor:pointer; transition:all .2s; display:flex; align-items:center; justify-content:center; gap:6px; }',
      '.lto-action-btn:hover { transform:translateY(-1px); }',
      '.lto-cart-btn { background:linear-gradient(135deg,#ec4899,#f43f5e); color:#fff; }',
      '.lto-cart-btn:hover { box-shadow:0 4px 12px rgba(244,63,94,0.4); }',
      '.lto-video-btn { background:linear-gradient(135deg,#8b5cf6,#6366f1); color:#fff; }',
      '.lto-video-btn:hover { box-shadow:0 4px 12px rgba(99,102,241,0.4); }',
      '.lto-retry-btn { background:#f3f4f6; color:#374151; }',
      '.lto-retry-btn:hover { background:#e5e7eb; }',
      '.lto-share-btn { background:#f3f4f6; color:#374151; }',
      '.lto-share-btn:hover { background:#e5e7eb; }',
      /* 360° 3D Model Viewer */
      '.lto-360-btn { background:linear-gradient(135deg,#0ea5e9,#0284c7); color:#fff; }',
      '.lto-360-btn:hover { box-shadow:0 4px 12px rgba(14,165,233,0.4); }',
      '.lto-spin-viewer { background:#fff; border-radius:16px; overflow:hidden; box-shadow:0 4px 20px rgba(0,0,0,0.12); margin-bottom:14px; }',
      '.lto-spin-title { display:flex; justify-content:space-between; align-items:center; padding:12px 16px; font-weight:700; font-size:14px; border-bottom:1px solid #f3f4f6; }',
      '.lto-spin-close { background:none; border:none; font-size:18px; cursor:pointer; color:#9ca3af; padding:4px 8px; }',
      '.lto-spin-canvas { position:relative; width:100%; height:400px; background:#f8f9fa; overflow:hidden; }',
      '.lto-spin-canvas model-viewer { width:100%; height:100%; }',
      '.lto-spin-status { text-align:center; padding:12px 16px; font-size:13px; color:#6b7280; }',
      '.lto-spin-status .lto-spin-progress { width:80%; height:4px; background:#e5e7eb; border-radius:2px; margin:8px auto 0; overflow:hidden; }',
      '.lto-spin-status .lto-spin-progress-bar { height:100%; background:linear-gradient(90deg,#0ea5e9,#0284c7); border-radius:2px; transition:width 0.3s; }',
      '.lto-spin-hint { text-align:center; padding:4px 8px 10px; font-size:11px; color:#9ca3af; }',
      '.lto-progress { position:absolute; inset:0; background:rgba(255,255,255,0.95); align-items:center; justify-content:center; z-index:10; backdrop-filter:blur(4px); }',
      '.lto-progress-inner { text-align:center; padding:40px; }',
      '.lto-spinner { width:48px; height:48px; border:4px solid #e9d5ff; border-top-color:#8b5cf6; border-radius:50%; animation:ltoSpin 0.9s linear infinite; margin:0 auto 16px; }',
      '.lto-progress-text { font-size:16px; font-weight:700; color:#1f2937; margin-bottom:4px; }',
      '.lto-progress-sub { font-size:12px; color:#9ca3af; }',
      /* Video Style Picker */
      '.lto-video-picker { padding:16px; background:#faf5ff; border-radius:16px; margin-top:12px; }',
      '.lto-video-picker-title { font-size:15px; font-weight:700; color:#1f2937; margin-bottom:4px; }',
      '.lto-video-picker-sub { font-size:12px; color:#6b7280; margin-bottom:12px; }',
      '.lto-video-style-grid { display:grid; grid-template-columns:repeat(2,1fr); gap:8px; margin-bottom:12px; }',
      '.lto-video-style-card { padding:12px 8px; background:#fff; border:2px solid #e5e7eb; border-radius:12px; text-align:center; cursor:pointer; transition:all .2s; }',
      '.lto-video-style-card:hover { border-color:#c4b5fd; background:#faf5ff; }',
      '.lto-video-style-card.selected { border-color:#8b5cf6; background:#f3e8ff; box-shadow:0 0 0 2px #c4b5fd; }',
      '.lto-video-style-icon { font-size:24px; margin-bottom:4px; }',
      '.lto-video-style-label { font-size:12px; font-weight:600; color:#374151; }',
      '.lto-video-cost { font-size:11px; color:#9ca3af; text-align:center; margin-bottom:8px; }',
      '.lto-video-cancel-btn { width:100%; padding:8px; background:none; border:1px solid #d1d5db; border-radius:10px; color:#6b7280; font-size:13px; cursor:pointer; }',
      /* Video Progress */
      '.lto-video-progress { position:fixed; bottom:0; right:16px; width:380px; max-width:calc(100vw - 32px); height:calc(100vh - 80px); max-height:680px; background:rgba(255,255,255,0.96); display:flex; align-items:center; justify-content:center; z-index:100002; backdrop-filter:blur(4px); border-radius:20px 20px 0 0; }',
      '.lto-video-progress-inner { text-align:center; padding:32px; width:90%; }',
      '.lto-video-spinner { width:44px; height:44px; border:4px solid #e9d5ff; border-top-color:#6366f1; border-radius:50%; animation:ltoSpin 0.9s linear infinite; margin:0 auto 14px; }',
      '.lto-video-progress-text { font-size:15px; font-weight:700; color:#1f2937; margin-bottom:4px; }',
      '.lto-video-progress-sub { font-size:12px; color:#6b7280; margin-bottom:16px; }',
      '.lto-video-bar-wrap { height:6px; background:#e5e7eb; border-radius:3px; overflow:hidden; margin-bottom:8px; }',
      '.lto-video-bar { height:100%; width:0%; background:linear-gradient(90deg,#8b5cf6,#6366f1); border-radius:3px; transition:width 1s linear; }',
      '.lto-video-timer { font-size:11px; color:#9ca3af; }',
      /* Video Player */
      '.lto-video-player { margin-top:12px; }',
      '.lto-video-player-title { font-size:14px; font-weight:700; color:#1f2937; margin-bottom:8px; }',
      '.lto-video-element { width:100%; border-radius:12px; background:#000; max-height:360px; }',
      /* Privacy note (Your Photo tab) */
      '.lto-privacy-note { font-size:12px; color:#64748b; padding:10px 12px; background:#f8fafc; border:1px solid #e2e8f0; border-radius:10px; margin-top:12px; line-height:1.5; }',
      '.lto-privacy-icon { font-weight:600; }',
      /* Side-by-side comparison panel */
      '.lto-compare { display:flex; gap:6px; align-items:stretch; position:relative; margin-bottom:8px; }',
      '.lto-compare-side { flex:1 1 0; position:relative; border-radius:10px; overflow:hidden; background:#f1f5f9; aspect-ratio:3/4; }',
      '.lto-compare-img { width:100%; height:100%; object-fit:cover; display:block; }',
      '.lto-compare-label { position:absolute; top:6px; left:6px; background:rgba(15,23,42,0.78); color:#fff; font-size:10px; padding:3px 8px; border-radius:999px; letter-spacing:.02em; z-index:2; }',
      '.lto-compare-swap { position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); width:36px; height:36px; border-radius:50%; border:0; background:#0f172a; color:#fff; font-size:18px; cursor:pointer; box-shadow:0 4px 12px rgba(0,0,0,.18); z-index:3; }',
      '.lto-compare-swap:hover { background:#1e293b; transform:translate(-50%,-50%) scale(1.05); }',
      '.lto-trust-note { font-size:11px; color:#10b981; text-align:center; margin-bottom:10px; font-weight:500; }',
      /* 24 Oct 2026: Mirror match feedback (brand purple #7C3AED, slate #485154, 44px tap targets) */
      '.lto-match { font-family:"Instrument Sans",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif; color:#485154; text-align:center; margin:4px 0 10px; font-size:13px; }',
      '.lto-match-row { display:flex; flex-wrap:wrap; align-items:center; justify-content:center; gap:6px 10px; }',
      '.lto-match-q { font-size:13px; font-weight:500; line-height:1.35; color:#485154; }',
      '.lto-match-btns { display:inline-flex; gap:8px; }',
      '.lto-match-btn { min-width:60px; min-height:44px; padding:0 18px; border-radius:999px; border:1.5px solid #7C3AED; background:#fff; color:#7C3AED; font-family:inherit; font-size:14px; font-weight:600; cursor:pointer; transition:background .15s ease, color .15s ease; }',
      '.lto-match-btn:hover:not(:disabled) { background:#F5F3FF; }',
      '.lto-match-btn.is-chosen { background:#7C3AED; color:#fff; }',
      '.lto-match-btn:disabled { cursor:default; }',
      '.lto-match-btn:disabled:not(.is-chosen) { opacity:.4; }',
      '.lto-match-btn:focus-visible, .lto-match-chip:focus-visible { outline:2px solid #7C3AED; outline-offset:2px; }',
      '.lto-match-reasons { display:flex; flex-wrap:wrap; justify-content:center; align-items:center; gap:6px; margin-top:8px; }',
      '.lto-match-why { width:100%; font-size:12px; color:#485154; }',
      '.lto-match-chip { min-height:44px; padding:0 14px; border-radius:999px; border:1px solid #CBD5E1; background:#fff; color:#485154; font-family:inherit; font-size:13px; font-weight:500; cursor:pointer; }',
      '.lto-match-chip:hover:not(:disabled) { border-color:#7C3AED; }',
      '.lto-match-chip.is-chosen { border-color:#7C3AED; background:#F5F3FF; color:#5B21B6; }',
      '.lto-match-chip:disabled { cursor:default; }',
      '.lto-match-chip:disabled:not(.is-chosen) { opacity:.45; }',
      '.lto-match-btn.is-chosen:disabled, .lto-match-chip.is-chosen:disabled { opacity:1; }',
      '.lto-match-thanks { margin-top:6px; font-size:13px; font-weight:500; color:#485154; }',
      '.lto-match-thanks:empty { display:none; }',
      /* Model chip — transparency line */
      '.lto-model-chip { font-size:11px; color:#64748b; text-align:center; padding:6px 10px; background:#f8fafc; border-radius:999px; margin:8px auto 12px; display:inline-block; max-width:100%; }',
      '.lto-model-chip-wrap { text-align:center; }',
      /* Fade-in for result */
      '.lto-compare, .lto-result-img-wrap { animation: ltoFadeIn .35s ease-out; }',
      '@keyframes ltoFadeIn { from{opacity:0; transform:translateY(6px)} to{opacity:1; transform:none} }',
      '.lto-video-actions { display:flex; gap:8px; margin-top:10px; }',
      '.lto-video-download-btn { flex:1; background:linear-gradient(135deg,#6366f1,#8b5cf6); color:#fff; }',
      '.lto-video-share-btn { flex:1; background:#f3f4f6; color:#374151; }',
      '.lto-video-close-btn { width:100%; margin-top:8px; padding:8px; background:none; border:1px solid #d1d5db; border-radius:10px; color:#6b7280; font-size:13px; cursor:pointer; }',
      '@media (max-width:480px) {',
        '.lto-panel { right:0; width:100vw; max-width:100vw; height:100vh; max-height:100vh; border-radius:0; }',
        '.lto-avatar-grid { grid-template-columns:repeat(4,1fr); gap:6px; }',
        '.lto-video-progress { right:0; width:100vw; max-width:100vw; height:100vh; max-height:100vh; border-radius:0; }',
      '}'
    ].join('\n');
    document.head.appendChild(style);
  }

  // ==========================================
  // EVENT BINDING
  // ==========================================
  function bindEvents() {
    document.getElementById('ltoBack').addEventListener('click', closeTryOn);

    var tabs = document.querySelectorAll('.lto-tab');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener('click', function() {
        switchTab(this.getAttribute('data-tab'));
      });
    }

    document.getElementById('ltoAvatarGrid').addEventListener('click', function(e) {
      var avatar = e.target.closest('.lto-avatar');
      if (avatar) selectAvatar(avatar);
    });

    document.getElementById('ltoUploadZone').addEventListener('click', function() {
      document.getElementById('ltoFileInput').click();
    });

    document.getElementById('ltoFileInput').addEventListener('change', handleFileUpload);
    document.getElementById('ltoRemovePhoto').addEventListener('click', removeUploadedPhoto);
    document.getElementById('ltoCameraBtn').addEventListener('click', openCamera);
    document.getElementById('ltoGenerateBtn').addEventListener('click', generateTryOn);
    document.getElementById('ltoAddToCart').addEventListener('click', addToCart);
    document.getElementById('ltoMakeVideo').addEventListener('click', makeVideo);
    document.getElementById('lto360View').addEventListener('click', start360View);
    document.getElementById('ltoSpinClose').addEventListener('click', close360View);
    document.getElementById('ltoRetry').addEventListener('click', retryTryOn);
    document.getElementById('ltoShare').addEventListener('click', shareTryOn);

    // Side-by-side swap
    var swap = document.getElementById('ltoCompareSwap');
    if (swap) swap.addEventListener('click', function() {
      var L = document.getElementById('ltoCompareLeftImg');
      var R = document.getElementById('ltoCompareRightImg');
      var llab = document.querySelector('.lto-compare-left .lto-compare-label');
      var rlab = document.querySelector('.lto-compare-right .lto-compare-label');
      if (!L || !R) return;
      var tmp = L.src; L.src = R.src; R.src = tmp;
      if (llab && rlab) { var t2 = llab.textContent; llab.textContent = rlab.textContent; rlab.textContent = t2; }
    });
  }

  // ==========================================
  // OPEN / CLOSE
  // ==========================================
  function openTryOn(product) {
    if (!TRYON_CONFIG.tryon_enabled) {
      console.info('[Lucy TryOn] disabled by TRYON_ENABLED=false');
      return;
    }
    if (!product || !product.image) {
      console.warn('[Lucy TryOn] No product data');
      return;
    }
    // Defense-in-depth: accessory gate (David May 13)
    var _ptype = (product && product.type) || getCurrentProductType();
    if (isAccessoryProductType(_ptype)) {
      console.info('[Lucy TryOn] openTryOn blocked — accessory product type:', _ptype);
      return;
    }
    if (isKidsProduct(product)) {
      console.info('[Lucy TryOn] openTryOn blocked — kids product (no child photos)');
      return;
    }

    state.product = product;
    state.personImage = null;
    state.selectedAvatar = null;
    state.resultImage = null;
    state.cachedImageUrl = null;
    state.isGenerating = false;
    state.activeTab = 'avatars';

    // Magic Mirror fix (2026-06-25): re-render the model roster to match the GARMENT
    // being tried on (not the page). Women-first store -> default female; show male
    // only when the garment is clearly men's. Avatar clicks are delegated on
    // #ltoAvatarGrid, so resetting its children here is safe.
    try {
      var _gt = ((product.title || '') + ' ' + (product.type || '')).toLowerCase();
      var _isMen = /(^|[^a-z])(men|mens|man|male|boy|boys|gentlemen|gents|him|his)([^a-z]|$)/.test(_gt);
      var _gGender = _gt.trim() ? (_isMen ? 'male' : 'female') : 'female';
      var _grid = document.getElementById('ltoAvatarGrid');
      if (_grid) {
        var _av = AVATARS.filter(function(a) { return a.gender === _gGender; });
        if (!_av.length) _av = AVATARS.filter(function(a) { return a.gender === 'female'; });
        var _TRUSTED = ['lucy', 'sofia', 'lilith'];   // avatar_trust canonical fleet (same faces as Lucy's team)
        _av = _av.slice().sort(function(a, b) {
          var ia = _TRUSTED.indexOf(a.id), ib = _TRUSTED.indexOf(b.id);
          return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
        });
        while (_grid.firstChild) _grid.removeChild(_grid.firstChild);
        _av.forEach(function(av) {
          var _ae = el('div', { className: 'lto-avatar', 'data-avatar': av.id, 'data-url': av.url }, [
            el('img', { src: av.url, alt: av.label, loading: 'lazy' }),
            el('span', { className: 'lto-avatar-name', textContent: av.label }),
            el('span', { className: 'lto-avatar-check', textContent: '✓' })
          ]);
          _grid.appendChild(_ae);
        });
      }
    } catch (e) { console.warn('[Lucy TryOn] avatar re-render failed', e); }

    document.getElementById('ltoProductImg').src = product.image;
    document.getElementById('ltoProductName').textContent = product.title || 'Product';
    document.getElementById('ltoProductPrice').textContent = product.price || '';

    document.getElementById('ltoResult').style.display = 'none';
    document.getElementById('ltoProgress').style.display = 'none';
    document.getElementById('ltoGenerateWrap').style.display = '';
    document.getElementById('ltoGenHint').textContent = 'Select a model or upload your photo first';
    document.getElementById('ltoGenHint').style.color = '';
    document.getElementById('ltoGenerateBtn').disabled = true;

    var avatars = document.querySelectorAll('.lto-avatar');
    for (var i = 0; i < avatars.length; i++) avatars[i].classList.remove('selected');

    document.getElementById('ltoUploadPreview').style.display = 'none';
    document.getElementById('ltoUploadZone').style.display = '';

    // Show tabs and content
    document.querySelectorAll('.lto-tabs, .lto-generate-wrap').forEach(function(node) {
      node.style.display = '';
    });

    switchTab('avatars');
    // Unify (Jun 9 2026): dock the try-on panel INSIDE the Lucy chat box so there is
    // ONE box, not two. BUT only when the chat is actually OPEN — the chat host
    // (#aiChatWindow) is in the DOM even when closed (0x0). Docking into a closed chat
    // collapsed the .lto-in-chat panel (position:absolute; inset:0) to 0x0, so the PDP
    // "Virtual Try-On" button looked dead (panel opened invisibly). Fix (Jun 27 2026):
    // dock only when the chat is open; otherwise show the panel as its own standalone
    // modal (.lto-panel.active = position:fixed, full-screen on mobile).
    (function () {
      var _panel = document.getElementById('lucyTryOn');
      if (!_panel) return;
      var _host = document.getElementById('aiChatWindow')
               || document.querySelector('.ai-chat-window')
               || document.getElementById('aiChatContainer');
      var _hostOpen = false;
      if (_host) { var _hr = _host.getBoundingClientRect(); _hostOpen = (_hr.width > 50 && _hr.height > 50); }
      if (_hostOpen) {
        if (_panel.parentElement !== _host) {
          try { if (getComputedStyle(_host).position === 'static') _host.style.position = 'relative'; } catch (e) {}
          _host.appendChild(_panel);
        }
        _panel.classList.add('lto-in-chat');
      } else {
        // chat closed -> standalone modal: move back out of any collapsed chat host
        if (_panel.parentElement && _panel.parentElement !== document.body) {
          document.body.appendChild(_panel);
        }
        _panel.classList.remove('lto-in-chat');
      }
    })();
    document.getElementById('lucyTryOn').classList.add('active');
    state.isOpen = true;

    // Pre-warm VTON pod when user opens try-on panel (~30-45s head start)
    fetch('https://ai-api.wowstore.live/api/vton/prewarm', { method: 'POST' }).catch(function(){});

    console.log('[Lucy TryOn] Opened for:', product.title);
  }

  function closeTryOn() {
    document.getElementById('lucyTryOn').classList.remove('active');
    state.isOpen = false;
  }

  // ==========================================
  // TAB SWITCHING
  // ==========================================
  function switchTab(tab) {
    state.activeTab = tab;
    var tabs = document.querySelectorAll('.lto-tab');
    for (var i = 0; i < tabs.length; i++) {
      tabs[i].classList.toggle('active', tabs[i].getAttribute('data-tab') === tab);
    }
    document.getElementById('ltoAvatars').classList.toggle('active', tab === 'avatars');
    document.getElementById('ltoUpload').classList.toggle('active', tab === 'upload');
  }

  // ==========================================
  // AVATAR SELECTION
  // ==========================================
  function selectAvatar(avatarEl) {
    var avatars = document.querySelectorAll('.lto-avatar');
    for (var i = 0; i < avatars.length; i++) avatars[i].classList.remove('selected');

    avatarEl.classList.add('selected');
    state.selectedAvatar = avatarEl.getAttribute('data-avatar');
    state.personImage = avatarEl.getAttribute('data-url');
    state.personSource = 'avatar';

    document.getElementById('ltoGenerateBtn').disabled = false;
    document.getElementById('ltoGenHint').textContent = 'Ready! Click to see this outfit on the model';
  }

  // ==========================================
  // PHOTO UPLOAD
  // ==========================================
  function handleFileUpload(e) {
    var file = e.target.files && e.target.files[0];
    if (!file) return;

    if (file.size > MAX_FILE_SIZE) {
      alert('Photo is too large. Please use an image under 10MB.');
      return;
    }
    if (!file.type.startsWith('image/')) {
      alert('Please upload an image file (JPG, PNG, etc.)');
      return;
    }

    var reader = new FileReader();
    reader.onload = function(evt) {
      var base64 = evt.target.result;
      document.getElementById('ltoUploadedImg').src = base64;
      document.getElementById('ltoUploadPreview').style.display = '';
      document.getElementById('ltoUploadZone').style.display = 'none';

      state.personImage = base64;
      state.personSource = 'upload';

      document.getElementById('ltoGenerateBtn').disabled = false;
      document.getElementById('ltoGenHint').textContent = 'Ready! Click to see yourself in this outfit';
    };
    reader.readAsDataURL(file);
  }

  function removeUploadedPhoto() {
    document.getElementById('ltoUploadPreview').style.display = 'none';
    document.getElementById('ltoUploadZone').style.display = '';
    document.getElementById('ltoFileInput').value = '';
    state.personImage = null;
    state.personSource = null;
    document.getElementById('ltoGenerateBtn').disabled = true;
    document.getElementById('ltoGenHint').textContent = 'Upload a photo or take a selfie';
  }

  // ==========================================
  // CAMERA CAPTURE
  // ==========================================
  function openCamera() {
    var input = document.createElement('input');
    input.type = 'file';
    input.accept = 'image/*';
    input.setAttribute('capture', 'user');
    input.style.display = 'none';
    input.addEventListener('change', function(e) {
      handleFileUpload(e);
      if (input.parentNode) input.parentNode.removeChild(input);
    });
    document.body.appendChild(input);
    input.click();
  }

  // ==========================================
  // GENERATE TRY-ON (AI)
  // ==========================================
  function generateTryOn() {
    if (state.isGenerating || !state.personImage || !state.product) return;
    if (state.personSource !== 'avatar') {
      var ltoCb = document.getElementById('ltoConsentBox');
      if (!ltoCb || !ltoCb.checked) {
        var ltoRow = document.getElementById('ltoConsent');
        if (ltoRow) { ltoRow.style.outline = '2px solid #c0392b'; ltoRow.style.outlineOffset = '4px'; ltoRow.scrollIntoView({ block: 'center' }); }
        return;
      }
    }
    state.isGenerating = true;

    document.getElementById('ltoProgress').style.display = 'flex';
    document.getElementById('ltoProgressText').textContent = 'Lucy is dressing you up...';
    document.getElementById('ltoProgressSub').textContent = 'AI magic takes about 15-30 seconds';

    var btn = document.getElementById('ltoGenerateBtn');
    btn.querySelector('.lto-gen-text').style.display = 'none';
    btn.querySelector('.lto-gen-loader').style.display = '';
    btn.disabled = true;

    var body = {
      garment_image_url: state.product.image,
      garment_description: state.product.title || 'Fashion garment',
      category: guessCategory(state.product.title || ''),
      product_type: (state.product && state.product.type) || getCurrentProductType() || ''
    };

    if (state.personSource === 'avatar') {
      body.person_image_url = state.personImage;
    } else {
      var b64 = state.personImage;
      if (b64.indexOf(',') > -1) b64 = b64.split(',')[1];
      body.person_image_base64 = b64;
      body.consent_self = true;   // AI Act W1b: ticked above
    }

    fetch(TRYON_API + '/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.success && data.job_id) {
        state.jobId = data.job_id;
        pollForResult(data.job_id);
      } else {
        showError((data.detail && data.detail.message) || data.message || data.error || 'The Magic Mirror could not start');
      }
    })
    .catch(function(err) {
      showError('Connection error: ' + err.message);
    });
  }

  function pollForResult(jobId) {
    var startTime = Date.now();
    var messages = [
      'Analyzing your look...',
      'Fitting the garment...',
      'Adding realistic details...',
      'Almost ready...',
      'Perfecting the fit...'
    ];
    var msgIndex = 0;

    var interval = setInterval(function() {
      msgIndex++;
      if (msgIndex < messages.length) {
        document.getElementById('ltoProgressText').textContent = messages[msgIndex];
      }

      if (Date.now() - startTime > MAX_POLL_TIME) {
        clearInterval(interval);
        showError('Generation timed out. Please try again.');
        return;
      }

      fetch(TRYON_API + '/status/' + jobId)
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.status === 'completed' && data.image_url) {
            clearInterval(interval);
            showResult(data.image_url, data.processing_time_ms, data);
          } else if (data.status === 'failed') {
            clearInterval(interval);
            showError((data.error_code || /HTTP 5\d\d|timed? ?out|unavailable|cap reached|budget|paused|limit|SmartRouter|Seedream/i.test(String(data.error || ''))) ? 'Magic Mirror is taking a short break \u2014 please try again in a few minutes.' : (data.error || 'Generation failed. Try a different photo.'));  // 12 Oct 2026 uptime: never blame the photo for our outage
          }
        })
        .catch(function() { /* continue polling on network errors */ });
    }, POLL_INTERVAL);
  }

  // ==========================================
  // MIRROR MATCH FEEDBACK (24 Oct 2026, David): "Does it match?" Yes / No, one click,
  // optional reason after No. Posts to /tryon/feedback (table mirror_feedback).
  // No cookies and no personal data: render id, product/variant/colour, avatar id, locale.
  // ==========================================
  function mfbMerge(a, b) { var o = {}, k; for (k in a) o[k] = a[k]; for (k in b) o[k] = b[k]; return o; }
  function mfbLocale() {
    try { return String((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en').slice(0, 10); }
    catch (e) { return 'en'; }
  }
  function mfbVariantColour() {
    var out = { variant: '', colour: '' };
    try {
      var m = /[?&]variant=(\d+)/.exec(window.location.search || '');
      if (m) out.variant = m[1];
      if (!out.variant) {
        var inp = document.querySelector('form[action*="/cart/add"] [name="id"]');
        if (inp) out.variant = String(inp.value || '');
      }
      var ci = document.querySelector('input[type="radio"][name*="olor" i]:checked, input[type="radio"][name*="olour" i]:checked, input[type="radio"][name*="kleur" i]:checked');
      if (ci) out.colour = String(ci.value || '');
      if (!out.colour) {
        var cs = document.querySelector('select[name*="olor" i], select[name*="olour" i], select[name*="kleur" i]');
        if (cs) out.colour = String(cs.value || '');
      }
    } catch (e) {}
    return out;
  }
  var MFB_T = /^nl/i.test(mfbLocale()) ? {
    line: 'Vergelijk met de productfoto. Klopt het?',
    yes: 'Ja', no: 'Nee',
    yesAria: 'Ja, het klopt met het product', noAria: 'Nee, het klopt niet met het product',
    group: 'Klopt het Mirror-voorbeeld met het product?',
    why: 'Wat klopt er niet? (optioneel)',
    reasons: [['colour', 'Kleur'], ['shape', 'Vorm / lengte'], ['details', 'Details (zakken, knopen)'], ['other', 'Anders']],
    thanks: 'Dank je, zo stemmen we de Mirror beter af.'
  } : {
    line: 'Check it against the product photo. Does it match?',
    yes: 'Yes', no: 'No',
    yesAria: 'Yes, it matches the product', noAria: 'No, it does not match the product',
    group: 'Does the Mirror preview match the product?',
    why: "What's off? (optional)",
    reasons: [['colour', 'Colour'], ['shape', 'Shape / length'], ['details', 'Details (pockets, buttons)'], ['other', 'Other']],
    thanks: 'Thanks, this helps us tune the Mirror.'
  };
  function mfbSend(payload) {
    try {
      fetch(TRYON_API + '/feedback', {
        method: 'POST', credentials: 'omit', keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function() {});
    } catch (e) {}
  }
  function mountMatchFeedback(jobId) {
    var box = document.getElementById('ltoTrustNote');
    if (!box) return;
    while (box.firstChild) box.removeChild(box.firstChild);
    var p = state.product || {};
    var vc = ((window.location.pathname || '').indexOf('/products/') > -1) ? mfbVariantColour() : { variant: '', colour: '' };
    var base = {
      job_id: jobId || '',
      product_handle: p.handle || '',
      product_id: (p.id || '') + '',
      variant_id: vc.variant,
      colour: vc.colour,
      avatar: state.personSource === 'avatar' ? (state.selectedAvatar || '') : 'own_photo',
      garment_image_url: p.image || '',
      locale: mfbLocale(),
      surface: 'pdp-dressing-room'
    };
    var yes = el('button', { type: 'button', className: 'lto-match-btn', id: 'ltoMatchYes', 'aria-label': MFB_T.yesAria, 'aria-pressed': 'false', textContent: MFB_T.yes });
    var no = el('button', { type: 'button', className: 'lto-match-btn', id: 'ltoMatchNo', 'aria-label': MFB_T.noAria, 'aria-pressed': 'false', textContent: MFB_T.no });
    box.appendChild(el('div', { className: 'lto-match-row' }, [
      el('span', { className: 'lto-match-q', textContent: MFB_T.line }),
      el('span', { className: 'lto-match-btns' }, [yes, no])
    ]));
    var reasons = el('div', { className: 'lto-match-reasons', id: 'ltoMatchReasons', role: 'group', 'aria-label': MFB_T.why, style: 'display:none' }, [
      el('span', { className: 'lto-match-why', textContent: MFB_T.why })
    ]);
    var chips = [];
    MFB_T.reasons.forEach(function(r) {
      var c = el('button', { type: 'button', className: 'lto-match-chip', 'data-reason': r[0], 'aria-pressed': 'false', textContent: r[1] });
      c.addEventListener('click', function() {
        chips.forEach(function(x) { x.disabled = true; });
        c.classList.add('is-chosen'); c.setAttribute('aria-pressed', 'true');
        mfbSend({ job_id: base.job_id, reason: r[0] });
      });
      chips.push(c); reasons.appendChild(c);
    });
    box.appendChild(reasons);
    var thanks = el('div', { className: 'lto-match-thanks', role: 'status', 'aria-live': 'polite' });
    box.appendChild(thanks);
    if (!jobId) { yes.style.display = 'none'; no.style.display = 'none'; return; }
    function choose(btn, verdict) {
      yes.disabled = true; no.disabled = true;
      btn.classList.add('is-chosen'); btn.setAttribute('aria-pressed', 'true');
      mfbSend(mfbMerge(base, { verdict: verdict }));
      thanks.textContent = MFB_T.thanks;
      if (verdict === 'no') reasons.style.display = '';
    }
    yes.addEventListener('click', function() { choose(yes, 'yes'); });
    no.addEventListener('click', function() { choose(no, 'no'); });
  }

  // ==========================================
  // SHOW RESULT
  // ==========================================
  function showResult(imageUrl, timeMs, jobMeta) {
    state.resultImage = imageUrl;
    state.isGenerating = false;
    jobMeta = jobMeta || {};

    // Cache the image for later video generation (Fal.ai URLs expire)
    cacheResultImage(imageUrl);

    document.getElementById('ltoProgress').style.display = 'none';

    document.querySelectorAll('.lto-tabs, .lto-content, .lto-generate-wrap').forEach(function(node) {
      node.style.display = 'none';
    });

    // Side-by-side comparison panel: product (left) | result (right)
    var leftImg = document.getElementById('ltoCompareLeftImg');
    var rightImg = document.getElementById('ltoCompareRightImg');
    if (leftImg && state.product && state.product.image) leftImg.src = state.product.image;
    if (rightImg) rightImg.src = imageUrl;

    // Model chip — transparency: "Generated by Seedream 4.5 · Free try-on N of 500 today"
    try {
      var chip = document.getElementById('ltoModelChip');
      var modelName = (TRYON_CONFIG && TRYON_CONFIG.model_display) || 'Seedream 4.5';
      var remaining = jobMeta && (jobMeta.daily_tryons_remaining != null ? jobMeta.daily_tryons_remaining : null);
      var dailyLimit = (TRYON_CONFIG && TRYON_CONFIG.daily_free_limit) || 500;
      var chipTxt = 'Generated by ' + modelName;
      if (remaining != null && remaining >= 0) {
        var used = Math.max(1, dailyLimit - remaining);
        chipTxt += ' · Free Magic Mirror look #' + used + ' of ' + dailyLimit + ' today';
      }
      if (chip) chip.textContent = chipTxt;
    } catch (e) {}

    // 24 Oct 2026: honest line + "Does it match?" Yes / No for this render
    try { mountMatchFeedback((jobMeta && jobMeta.job_id) || state.jobId); } catch (e) {}

    // Keep legacy single result img populated as fallback (used by some downstream
    // hooks like the video pipeline and 360° viewer).
    document.getElementById('ltoResultImg').src = imageUrl;
    document.getElementById('ltoResult').style.display = '';

    var btn = document.getElementById('ltoGenerateBtn');
    btn.querySelector('.lto-gen-text').style.display = '';
    btn.querySelector('.lto-gen-loader').style.display = 'none';
    btn.disabled = false;

    // Check if product is eligible for 360° view
    check360Eligibility();

    // Conversion logging — best-effort, never blocks UX
    try {
      fetch(TRYON_API + '/log-conversion', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          viewer_session_id: VIEWER_SESSION_ID,
          product_id: (state.product && (state.product.id || '')) + '',
          tryon_image_url: imageUrl,
          garment_image_url: (state.product && state.product.image) || '',
          model_used: (jobMeta && jobMeta.model) || 'ByteDance-Seedream-4.5/251128'
        })
      }).catch(function(){});
    } catch (e) {}

    console.log('[Lucy TryOn] Result ready in ' + (timeMs || '?') + 'ms:', imageUrl);
  }

  function showError(msg) {
    state.isGenerating = false;
    document.getElementById('ltoProgress').style.display = 'none';

    var btn = document.getElementById('ltoGenerateBtn');
    btn.querySelector('.lto-gen-text').style.display = '';
    btn.querySelector('.lto-gen-loader').style.display = 'none';
    btn.disabled = false;

    // Friendly customer-facing translation — never leak quota internals.
    var friendly = msg || 'Try again in a moment';
    var lower = (msg || '').toString().toLowerCase();
    if (lower.indexOf('daily_tryon_limit') > -1 || lower.indexOf('quota') > -1 ||
        lower.indexOf('limit_reached') > -1 || lower.indexOf('insufficient') > -1) {
      friendly = "Today's free Magic Mirror looks are full — come back tomorrow.";
    } else if (lower.indexOf('503') > -1 || lower.indexOf('timed out') > -1) {
      friendly = 'Try again in a moment';
    }

    document.getElementById('ltoGenHint').textContent = friendly;
    document.getElementById('ltoGenHint').style.color = '#ef4444';
    setTimeout(function() {
      var hint = document.getElementById('ltoGenHint');
      if (hint) hint.style.color = '';
    }, 5000);

    console.warn('[Lucy TryOn] Error:', msg);
  }

  // ==========================================
  // RESULT ACTIONS
  // ==========================================
  function addToCart() {
    if (!state.product) return;
    var lineProps = {
      '_tryon_session_id': VIEWER_SESSION_ID,
      '_tryon_image_url': state.resultImage || '',
      '_tryon_at': new Date().toISOString()
    };
    var btn = document.getElementById('ltoAddToCart');
    function doAdd(variantId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1, properties: lineProps })
      }).then(function(res) {
        if (!res.ok) throw new Error('add failed ' + res.status);
        return res.json();
      }).then(function() {
        if (btn) { btn.textContent = '\u2705 Added!'; setTimeout(function(){ btn.textContent = '\uD83D\uDED2 Add to Cart'; }, 2000); }
        try { document.dispatchEvent(new CustomEvent('lucy:cart:added')); } catch (e) {}
      });
    }
    var variantId = state.product.variantId;
    if (variantId) { doAdd(variantId).catch(function(){ if (state.product.url) window.open(state.product.url, '_blank'); }); return; }
    var handle = state.product.handle
      || (state.product.url ? (state.product.url.split('/products/')[1] || '').split('?')[0].split('/')[0] : '')
      || (location.pathname.indexOf('/products/') >= 0 ? location.pathname.split('/products/')[1].split('?')[0] : '');
    if (handle) {
      fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(p){
        var v = (p.variants || []).filter(function(x){ return x.available; })[0] || (p.variants || [])[0];
        if (v) return doAdd(v.id);
        throw new Error('no variant');
      }).catch(function(){ if (state.product.url) window.open(state.product.url, '_blank'); });
    } else if (state.product.url) {
      window.open(state.product.url, '_blank');
    }
  }

  // ==========================================
  // VIDEO GENERATION (Kling v2.6 Pro via Fal.ai)
  // ==========================================
  // ==========================================
  // IMAGE CACHING (Fal.ai URLs expire after ~1hr)
  // ==========================================
  function cacheResultImage(imageUrl) {
    if (!imageUrl || state.cachedImageUrl) return;
    fetch(TRYON_API + '/cache-image', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ image_url: imageUrl })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.cached && data.permanent_url) {
        state.cachedImageUrl = data.permanent_url;
        console.log('[Lucy TryOn] Image cached at:', data.permanent_url);
      }
    })
    .catch(function(err) {
      console.warn('[Lucy TryOn] Image cache failed:', err);
    });
  }

  var VIDEO_STYLES = [
    { id: 'fashion_walk', label: 'Fashion Walk', icon: '\uD83D\uDEB6\u200D\u2640\uFE0F' },
    { id: 'confident_turn', label: 'Confident Turn', icon: '\uD83D\uDD04' },
    { id: 'lifestyle', label: 'Lifestyle', icon: '\uD83C\uDF07' },
    { id: 'runway', label: 'Runway', icon: '\u2728' }
  ];
  var VIDEO_POLL_INTERVAL = 5000;
  var VIDEO_MAX_POLL = 300000; // 5 min max client-side (Kling takes 60-180s)

  function makeVideo() {
    if (!state.resultImage) return;
    showVideoStylePicker();
  }

  function showVideoStylePicker() {
    // Remove any existing picker
    var existing = document.getElementById('ltoVideoPicker');
    if (existing) existing.remove();

    var picker = el('div', { id: 'ltoVideoPicker', className: 'lto-video-picker' });

    var pickerTitle = el('div', { className: 'lto-video-picker-title', textContent: '\uD83C\uDFAC Create Your Fashion Video' });
    picker.appendChild(pickerTitle);

    var pickerSub = el('div', { className: 'lto-video-picker-sub', textContent: 'Choose a style to animate your Magic Mirror look' });
    picker.appendChild(pickerSub);

    var grid = el('div', { className: 'lto-video-style-grid' });
    for (var i = 0; i < VIDEO_STYLES.length; i++) {
      var vs = VIDEO_STYLES[i];
      var card = el('div', { className: 'lto-video-style-card', 'data-style': vs.id });
      card.appendChild(el('div', { className: 'lto-video-style-icon', textContent: vs.icon }));
      card.appendChild(el('div', { className: 'lto-video-style-label', textContent: vs.label }));
      card.addEventListener('click', (function(styleId) {
        return function() {
          // Highlight selected
          var cards = document.querySelectorAll('.lto-video-style-card');
          for (var j = 0; j < cards.length; j++) cards[j].classList.remove('selected');
          this.classList.add('selected');
          // Start generation
          startVideoGeneration(styleId);
        };
      })(vs.id));
      grid.appendChild(card);
    }
    picker.appendChild(grid);

    var costNote = el('div', { className: 'lto-video-cost', textContent: '5-second AI video \u2022 ~90-120 seconds to create' });
    picker.appendChild(costNote);

    var cancelBtn = el('button', { className: 'lto-video-cancel-btn', textContent: 'Cancel' });
    cancelBtn.addEventListener('click', function() {
      var p = document.getElementById('ltoVideoPicker');
      if (p) p.remove();
    });
    picker.appendChild(cancelBtn);

    // Insert after result section
    var resultSection = document.getElementById('ltoResult');
    resultSection.appendChild(picker);
  }

  function startVideoGeneration(styleId) {
    // Remove picker
    var picker = document.getElementById('ltoVideoPicker');
    if (picker) picker.remove();

    // Show video progress UI
    showVideoProgress();

    // Store current video style for Fame tracking
    state._currentVideoStyle = styleId;

    // Use cached URL if available (Fal.ai temp URLs expire)
    var videoImageUrl = state.cachedImageUrl || state.resultImage;
    console.log('[Lucy TryOn] Starting video generation | style=' + styleId + ' | image=' + videoImageUrl.substring(0, 60) + '...');

    // SHADOW-QUEUE the request for v3 Seedance Pro pipeline. When v3 lands it
    // will claim this row and override the Kling result. Best-effort, fire-and-forget.
    try {
      fetch(TRYON_API + '/queue-fashion-video', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          viewer_session_id: VIEWER_SESSION_ID,
          tryon_image_url: videoImageUrl,
          product_id: (state.product && (state.product.id || '')) + '',
          style: styleId,
          duration: '5'
        })
      }).catch(function(){});
    } catch (e) {}

    fetch(TRYON_API + '/video/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        image_url: videoImageUrl,
        style: styleId,
        duration: '5',
        product_title: state.product ? state.product.title : ''
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.success && data.job_id) {
        console.log('[Lucy TryOn] Video job started: ' + data.job_id);
        pollVideoResult(data.job_id);
      } else {
        console.error('[Lucy TryOn] Video generate failed:', data);
        showVideoError(data.error || 'Failed to start video generation');
      }
    })
    .catch(function(err) {
      console.error('[Lucy TryOn] Video API error:', err);
      showVideoError('Connection error. Please try again.');
    });
  }

  function showVideoProgress() {
    var existing = document.getElementById('ltoVideoProgress');
    if (existing) existing.remove();

    var overlay = el('div', { id: 'ltoVideoProgress', className: 'lto-video-progress' });
    var inner = el('div', { className: 'lto-video-progress-inner' });

    inner.appendChild(el('div', { className: 'lto-video-spinner' }));
    inner.appendChild(el('div', { id: 'ltoVideoText', className: 'lto-video-progress-text', textContent: 'Creating your fashion video...' }));
    inner.appendChild(el('div', { id: 'ltoVideoSub', className: 'lto-video-progress-sub', textContent: 'AI is animating your Magic Mirror look' }));

    // Progress bar
    var barWrap = el('div', { className: 'lto-video-bar-wrap' });
    barWrap.appendChild(el('div', { id: 'ltoVideoBar', className: 'lto-video-bar' }));
    inner.appendChild(barWrap);

    inner.appendChild(el('div', { id: 'ltoVideoTimer', className: 'lto-video-timer', textContent: 'Estimated: ~90-120 seconds' }));

    overlay.appendChild(inner);

    // Append to body (fixed position overlay covers the panel)
    document.body.appendChild(overlay);

    // Animate progress messages
    var messages = [
      'Creating your fashion video...',
      'AI is analyzing the outfit...',
      'Generating natural movement...',
      'Adding fashion lighting...',
      'Refining details...',
      'Almost there...'
    ];
    var msgIdx = 0;
    state._videoProgressTimer = setInterval(function() {
      msgIdx = (msgIdx + 1) % messages.length;
      var textEl = document.getElementById('ltoVideoText');
      if (textEl) textEl.textContent = messages[msgIdx];
    }, 8000);

    // Animate progress bar (fake but smooth over 120s)
    state._videoBarTimer = (function() {
      var startTime = Date.now();
      var est = 120000;
      var timerId = setInterval(function() {
        var elapsed = Date.now() - startTime;
        var pct = Math.min(92, (elapsed / est) * 90);
        var bar = document.getElementById('ltoVideoBar');
        if (bar) bar.style.width = pct + '%';
        var timer = document.getElementById('ltoVideoTimer');
        if (timer) {
          var remaining = Math.max(0, Math.ceil((est - elapsed) / 1000));
          timer.textContent = remaining > 0 ? '~' + remaining + ' seconds remaining' : 'Finishing up...';
        }
      }, 1000);
      return timerId;
    })();
  }

  function clearVideoProgress() {
    if (state._videoProgressTimer) { clearInterval(state._videoProgressTimer); state._videoProgressTimer = null; }
    if (state._videoBarTimer) { clearInterval(state._videoBarTimer); state._videoBarTimer = null; }
  }

  function pollVideoResult(jobId) {
    var startTime = Date.now();

    var poller = setInterval(function() {
      if (Date.now() - startTime > VIDEO_MAX_POLL) {
        clearInterval(poller);
        clearVideoProgress();
        showVideoError('Video generation took too long. Try again later.');
        return;
      }

      fetch(TRYON_API + '/video/status/' + jobId)
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.status === 'completed' && data.video_url) {
            clearInterval(poller);
            clearVideoProgress();
            console.log('[Lucy TryOn] Video ready in ' + data.processing_time_ms + 'ms: ' + data.video_url);
            showVideoResult(data.video_url);
          } else if (data.status === 'failed') {
            clearInterval(poller);
            clearVideoProgress();
            console.error('[Lucy TryOn] Video failed:', data.error);
            showVideoError(data.error || 'Video generation failed');
          }
          // else still processing — keep polling
        })
        .catch(function(err) {
          console.warn('[Lucy TryOn] Video poll error:', err);
        });
    }, VIDEO_POLL_INTERVAL);
  }

  function showVideoResult(videoUrl) {
    // Remove progress overlay
    var prog = document.getElementById('ltoVideoProgress');
    if (prog) prog.remove();

    // Remove any existing video player
    var existingPlayer = document.getElementById('ltoVideoPlayer');
    if (existingPlayer) existingPlayer.remove();

    // ── Lucy Fame: Track this WowMoment ──
    var fameShareUrl = videoUrl; // fallback to raw URL
    var browserId = (window.LucyQuota && window.LucyQuota.getBrowserId) ? window.LucyQuota.getBrowserId() : '';
    if (browserId) {
      try {
        fetch('https://ai-api.wowstore.live/api/lucy/fame/track-video', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            browser_id: browserId,
            video_url: videoUrl,
            tryon_image_url: state.cachedImageUrl || state.resultImage || '',
            product_id: state.product ? (state.product.id || null) : null,
            product_title: state.product ? (state.product.title || '') : '',
            product_handle: state.product ? (state.product.handle || '') : '',
            product_image_url: state.product ? (state.product.image || '') : '',
            video_style: state._currentVideoStyle || 'fashion_walk',
            video_duration: 5
          })
        })
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (data.success && data.share_url) {
            state._fameShareUrl = data.share_url;
            state._fameShareCode = data.share_code;
            state._fameVideoId = data.fame_video_id;
            console.log('[Lucy Fame] WowMoment tracked: ' + data.share_code);
          }
        })
        .catch(function(err) {
          console.warn('[Lucy Fame] Track failed (non-blocking):', err);
        });
      } catch(e) { /* non-blocking */ }
    }

    var playerWrap = el('div', { id: 'ltoVideoPlayer', className: 'lto-video-player' });

    var playerTitle = el('div', { className: 'lto-video-player-title', textContent: '\uD83C\uDFAC Your WowMoment Video' });
    playerWrap.appendChild(playerTitle);

    var video = document.createElement('video');
    video.className = 'lto-video-element';
    video.src = videoUrl;
    video.controls = true;
    video.autoplay = true;
    video.loop = true;
    video.playsInline = true;
    video.muted = true;
    playerWrap.appendChild(video);

    var videoActions = el('div', { className: 'lto-video-actions' });

    var downloadBtn = el('button', { className: 'lto-action-btn lto-video-download-btn', textContent: '\u2B07\uFE0F Download' });
    downloadBtn.addEventListener('click', function() {
      window.open(videoUrl, '_blank');
    });
    videoActions.appendChild(downloadBtn);

    var shareVideoBtn = el('button', { className: 'lto-action-btn lto-video-share-btn', textContent: '\uD83D\uDCE4 Share WowMoment' });
    shareVideoBtn.addEventListener('click', function() {
      // Use Fame share URL if available, fallback to raw video URL
      var shareUrl = state._fameShareUrl || videoUrl;
      var shareTitle = 'My WowMoment - ' + (state.product ? state.product.title : 'WowStore');
      var shareText = 'What do you think of this outfit? \u2728 Try it on yourself at WowStore!';
      if (navigator.share) {
        navigator.share({
          title: shareTitle,
          text: shareText,
          url: shareUrl
        }).catch(function() {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(shareUrl).then(function() {
          shareVideoBtn.textContent = '\u2705 Link Copied!';
          setTimeout(function() { shareVideoBtn.textContent = '\uD83D\uDCE4 Share WowMoment'; }, 2000);
        });
      }
      // Track share event
      if (window.LucyAnalytics && window.LucyAnalytics.track) {
        window.LucyAnalytics.track('fame_video_shared', {
          share_code: state._fameShareCode || '',
          product: state.product ? state.product.handle : ''
        });
      }
    });
    videoActions.appendChild(shareVideoBtn);
    playerWrap.appendChild(videoActions);

    var closeVideoBtn = el('button', { className: 'lto-video-close-btn', textContent: '\u2190 Back to Photo' });
    closeVideoBtn.addEventListener('click', function() {
      var p = document.getElementById('ltoVideoPlayer');
      if (p) p.remove();
    });
    playerWrap.appendChild(closeVideoBtn);

    // Insert into result section
    var resultSection = document.getElementById('ltoResult');
    resultSection.appendChild(playerWrap);

    // Auto-play
    video.play().catch(function() {});
  }

  function showVideoError(msg) {
    var prog = document.getElementById('ltoVideoProgress');
    if (prog) prog.remove();

    var btn = document.getElementById('ltoMakeVideo');
    if (btn) {
      btn.textContent = '\u274C ' + (msg.length > 30 ? msg.substring(0, 28) + '...' : msg);
      btn.disabled = true;
      setTimeout(function() {
        btn.textContent = '\uD83C\uDFAC Make Video';
        btn.disabled = false;
      }, 4000);
    }
  }

  function retryTryOn() {
    state.resultImage = null;
    state.jobId = null;
    state.isGenerating = false;
    try {
      ['ltoCompareRightImg', 'ltoResultImg'].forEach(function(id) { var im = document.getElementById(id); if (im) im.removeAttribute('src'); });
      var fb = document.getElementById('ltoTrustNote'); if (fb) while (fb.firstChild) fb.removeChild(fb.firstChild);
      var mc = document.getElementById('ltoModelChip'); if (mc) mc.textContent = '';
      if (state.personImage) {
        var gh = document.getElementById('ltoGenHint');
        if (gh) gh.textContent = 'Tap again for a new variation, or pick another model';
        var gb = document.getElementById('ltoGenerateBtn'); if (gb) gb.disabled = false;
      }
    } catch (e) {}
    // Reset 360° 3D viewer
    close360View();
    spin360State.eligible = false;
    spin360State.glbUrl = null;
    spin360State.glbCached = false;
    var btn360 = document.getElementById('lto360View');
    if (btn360) btn360.style.display = 'none';

    document.querySelectorAll('.lto-tabs, .lto-generate-wrap').forEach(function(node) {
      node.style.display = '';
    });
    switchTab(state.activeTab);
    document.getElementById('ltoResult').style.display = 'none';
  }

  function shareTryOn() {
    if (!state.resultImage) return;
    var shareUrl = state._fameShareUrl || state.resultImage;
    var shareTitle = 'My WowMoment - ' + (state.product.title || 'WowStore');
    var shareText = 'What do you think? \u2728 Try it on yourself at WowStore!';
    if (navigator.share) {
      navigator.share({
        title: shareTitle,
        text: shareText,
        url: shareUrl
      }).catch(function() {});
    } else if (navigator.clipboard) {
      navigator.clipboard.writeText(shareUrl).then(function() {
        var btn = document.getElementById('ltoShare');
        btn.textContent = '\u2705 Link Copied!';
        setTimeout(function() { btn.textContent = '\uD83D\uDCE4 Share'; }, 2000);
      });
    }
  }

  // ==========================================
  // 360° SPIN VIEWER
  // ==========================================
  var spin360State = {
    eligible: false,
    generating: false,
    glbCached: false,
    glbUrl: null
  };

  function check360Eligibility() {
    // Called after try-on result is shown — check if product is suitable for 360° 3D view
    if (!state.product || !state.product.image) return;

    var productType = (state.product.type || '').toLowerCase();
    var productTags = [];
    var shopifyProductId = null;
    var imageUrls = [];

    // Extract Shopify product data if available
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      var m = window.ShopifyAnalytics.meta.product;
      if (m.tags) productTags = m.tags;
      if (m.id) shopifyProductId = parseInt(m.id);
    }

    // Collect all product image URLs from the page
    try {
      var mediaImgs = document.querySelectorAll('.product__media img[src*="cdn.shopify.com"]');
      mediaImgs.forEach(function(img) {
        var src = img.src || img.getAttribute('data-src') || '';
        if (src && imageUrls.indexOf(src) === -1) imageUrls.push(src);
      });
    } catch(e) {}

    var payload = {
      product_image_url: state.product.image,
      product_type: productType,
      product_tags: productTags
    };
    if (shopifyProductId) payload.shopify_product_id = shopifyProductId;
    if (imageUrls.length > 0) payload.image_urls = imageUrls;

    fetch(TRYON_API + '/360/check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      spin360State.eligible = data.eligible;
      spin360State.glbCached = data.glb_cached || false;
      var btn = document.getElementById('lto360View');
      if (data.eligible && btn) {
        btn.style.display = '';
        if (data.glb_cached) btn.textContent = '\uD83D\uDD04 360\u00B0 View';
        console.log('[Lucy TryOn] 360° eligible: score ' + data.score + (data.glb_cached ? ' (cached)' : ''));
      } else {
        btn.style.display = 'none';
        console.log('[Lucy TryOn] 360° not eligible: ' + (data.reason || 'unknown'));
      }
    })
    .catch(function(err) {
      console.warn('[Lucy TryOn] 360° eligibility check failed:', err);
    });
  }

  function start360View() {
    if (spin360State.generating || !state.product) return;
    spin360State.generating = true;

    var btn = document.getElementById('lto360View');
    btn.textContent = '\u23F3 Generating 3D...';
    btn.disabled = true;

    var browserId = (window.LucyQuota && window.LucyQuota.getBrowserId) ? window.LucyQuota.getBrowserId() : '';
    var shopifyProductId = null;
    var imageUrls = [];

    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      shopifyProductId = parseInt(window.ShopifyAnalytics.meta.product.id);
    }
    // Collect product images from page
    try {
      document.querySelectorAll('.product__media img[src*="cdn.shopify.com"]').forEach(function(img) {
        var src = img.src || img.getAttribute('data-src') || '';
        if (src && imageUrls.indexOf(src) === -1) imageUrls.push(src);
      });
    } catch(e) {}

    if (!shopifyProductId) {
      btn.textContent = '\uD83D\uDD04 360\u00B0 View';
      btn.disabled = false;
      spin360State.generating = false;
      console.warn('[Lucy TryOn] 360°: No Shopify product ID found');
      return;
    }

    var payload = { shopify_product_id: shopifyProductId, browser_id: browserId };
    if (imageUrls.length > 0) payload.image_urls = imageUrls;

    fetch(TRYON_API + '/360/generate', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.status === 'completed' && data.glb_url) {
        // GLB ready (cached hit) — show immediately
        spin360State.generating = false;
        btn.disabled = false;
        btn.textContent = '\uD83D\uDD04 360\u00B0 View';
        show3DViewer(data.glb_url);
        console.log('[Lucy TryOn] 360° GLB loaded (cached)');
      } else if (data.status === 'processing' && data.job_id) {
        // Generation in progress — show progress and poll
        showGenerationProgress('Creating 3D model...', 10);
        poll360Status(data.job_id, btn);
      } else if (data.error === 'insufficient_tokens') {
        spin360State.generating = false;
        btn.disabled = false;
        btn.textContent = '\uD83D\uDD04 360\u00B0 View';
        if (window.LucyQuota && window.LucyQuota.showPaywall) {
          window.LucyQuota.showPaywall('360° View costs 2 tokens');
        } else {
          alert('360° View costs 2 tokens.');
        }
      } else if (data.error === 'not_eligible') {
        spin360State.generating = false;
        btn.disabled = false;
        btn.style.display = 'none';
        console.log('[Lucy TryOn] 360° not eligible:', data.reason);
      } else {
        spin360State.generating = false;
        btn.disabled = false;
        btn.textContent = '\u274C 360\u00B0 failed';
        setTimeout(function() { btn.textContent = '\uD83D\uDD04 360\u00B0 View'; }, 3000);
        console.error('[Lucy TryOn] 360° error:', data.error || data.message);
      }
    })
    .catch(function(err) {
      spin360State.generating = false;
      btn.disabled = false;
      btn.textContent = '\uD83D\uDD04 360\u00B0 View';
      console.error('[Lucy TryOn] 360° request failed:', err);
    });
  }

  function poll360Status(jobId, btn) {
    var pollCount = 0;
    var maxPolls = 60; // 5s × 60 = 5 min max
    var pollInterval = setInterval(function() {
      pollCount++;
      var progress = Math.min(90, 10 + pollCount * 1.5);
      showGenerationProgress(pollCount < 6 ? 'Analyzing product image...' : pollCount < 12 ? 'Removing background...' : 'Building 3D model...', progress);

      fetch(TRYON_API + '/360/status/' + jobId)
      .then(function(res) { return res.json(); })
      .then(function(data) {
        if (data.status === 'completed' && data.glb_url) {
          clearInterval(pollInterval);
          spin360State.generating = false;
          btn.disabled = false;
          btn.textContent = '\uD83D\uDD04 360\u00B0 View';
          hideGenerationProgress();
          show3DViewer(data.glb_url);
          if (window.LucyQuota && window.LucyQuota.invalidateCache) window.LucyQuota.invalidateCache();
          console.log('[Lucy TryOn] 360° 3D model ready');
        } else if (data.status === 'failed') {
          clearInterval(pollInterval);
          spin360State.generating = false;
          btn.disabled = false;
          btn.textContent = '\u274C 3D failed';
          hideGenerationProgress();
          setTimeout(function() { btn.textContent = '\uD83D\uDD04 360\u00B0 View'; }, 3000);
          console.error('[Lucy TryOn] 360° generation failed:', data.error);
        }
      })
      .catch(function() {});

      if (pollCount >= maxPolls) {
        clearInterval(pollInterval);
        spin360State.generating = false;
        btn.disabled = false;
        btn.textContent = '\uD83D\uDD04 360\u00B0 View';
        hideGenerationProgress();
      }
    }, 5000);
  }

  function showGenerationProgress(msg, pct) {
    var statusEl = document.getElementById('ltoSpinStatus');
    var viewer = document.getElementById('ltoSpinViewer');
    viewer.style.display = '';
    statusEl.style.display = '';
    statusEl.innerHTML = '<div>' + msg + '</div><div class="lto-spin-progress"><div class="lto-spin-progress-bar" style="width:' + pct + '%"></div></div>';
    document.getElementById('ltoResultImg').parentNode.style.display = 'none';
  }

  function hideGenerationProgress() {
    var statusEl = document.getElementById('ltoSpinStatus');
    statusEl.style.display = 'none';
  }

  function show3DViewer(glbUrl) {
    // Load model-viewer web component if not already loaded
    if (!document.querySelector('script[src*="model-viewer"]')) {
      var script = document.createElement('script');
      script.type = 'module';
      script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
      document.head.appendChild(script);
    }

    var viewer = document.getElementById('ltoSpinViewer');
    var canvas = document.getElementById('ltoSpinCanvas');

    // Clear previous content
    canvas.innerHTML = '';

    // Create model-viewer element
    var mv = document.createElement('model-viewer');
    mv.setAttribute('src', glbUrl);
    mv.setAttribute('camera-controls', '');
    mv.setAttribute('auto-rotate', '');
    mv.setAttribute('auto-rotate-delay', '0');
    mv.setAttribute('rotation-per-second', '30deg');
    mv.setAttribute('shadow-intensity', '1');
    mv.setAttribute('shadow-softness', '0.8');
    mv.setAttribute('environment-image', 'neutral');
    mv.setAttribute('exposure', '1.1');
    mv.setAttribute('tone-mapping', 'commerce');
    mv.setAttribute('camera-orbit', '0deg 75deg 105%');
    mv.setAttribute('min-camera-orbit', 'auto auto 50%');
    mv.setAttribute('max-camera-orbit', 'auto auto 200%');
    mv.setAttribute('interaction-prompt', 'auto');
    mv.setAttribute('loading', 'eager');
    mv.setAttribute('ar', '');
    mv.setAttribute('ar-modes', 'webxr scene-viewer quick-look');
    mv.style.width = '100%';
    mv.style.height = '100%';
    mv.style.minHeight = '380px';
    canvas.appendChild(mv);

    // Show the viewer, hide the result image
    document.getElementById('ltoResultImg').parentNode.style.display = 'none';
    viewer.style.display = '';

    // Store GLB URL for later
    spin360State.glbUrl = glbUrl;

    console.log('[Lucy TryOn] 3D model viewer loaded:', glbUrl);
  }

  function close360View() {
    var viewer = document.getElementById('ltoSpinViewer');
    var canvas = document.getElementById('ltoSpinCanvas');
    viewer.style.display = 'none';
    canvas.innerHTML = '';
    document.getElementById('ltoResultImg').parentNode.style.display = '';
  }

  // ==========================================
  // HELPERS
  // ==========================================
  function guessCategory(title) {
    var t = title.toLowerCase();
    if (t.match(/dress|jumpsuit|romper|bodysuit|overall/)) return 'one-pieces';
    if (t.match(/pant|jean|trouser|short|skirt|legging/)) return 'bottoms';
    return 'tops';
  }

  // ==========================================
  // AUTO-INJECT "TRY IT ON" BUTTON ON PRODUCT PAGES
  // ==========================================
  function injectProductPageButton() {
    // Only on product pages
    if (!window.location.pathname.startsWith('/products/')) return;
    // Don't double-inject
    if (document.getElementById('lucyTryOnProductBtn')) return;

    // Accessory gate (David May 13): hide Try-On button for non-apparel
    // (jewelry, bags, hats, POD mugs/bottles/phone-case, etc.). The current
    // Seedream-4.5 flow can't sensibly composite these onto an avatar.
    var _ptype = getCurrentProductType();
    if (isAccessoryProductType(_ptype)) {
      console.info('[Lucy TryOn] Button suppressed — accessory product type:', _ptype);
      return;
    }
    if (isKidsProduct(null)) {
      console.info('[Lucy TryOn] Button suppressed — kids product (no child photos)');
      return;
    }

    // Get product data from Shopify
    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    var productImage = document.querySelector('meta[property="og:image"]');
    var productTitle = document.querySelector('meta[property="og:title"]');
    var priceEl = document.querySelector('.price-item--regular, .product__price, .price .money, [class*="price"] .money');

    if (!productImage) return;

    var product = {
      image: productImage.content,
      title: (productTitle && productTitle.content) || document.title.split('|')[0].trim(),
      price: priceEl ? priceEl.textContent.trim() : '',
      type: (meta && meta.type) || '',
      id: (meta && meta.id) || '',
      handle: window.location.pathname.split('/').pop()
    };

    // Create the button
    var btn = document.createElement('button');
    btn.id = 'lucyTryOnProductBtn';
    btn.type = 'button';
    btn.setAttribute('style',
      'display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:14px 24px;' +
      'margin:12px 0 8px;border:2px solid #DB2777;border-radius:12px;background:linear-gradient(135deg,#FDF2F8,#FCE7F3);' +
      'color:#DB2777;font-size:15px;font-weight:700;cursor:pointer;transition:all 0.3s ease;' +
      'font-family:inherit;letter-spacing:0.3px;position:relative;overflow:hidden;'
    );

    var sparkle = document.createElement('span');
    sparkle.setAttribute('style', 'font-size:18px;');
    sparkle.textContent = '\u2728';

    var text = document.createElement('span');
    text.textContent = 'Try it in the Dressing Room';

    var badge = document.createElement('span');
    badge.setAttribute('style',
      'background:#DB2777;color:white;font-size:10px;padding:2px 6px;border-radius:6px;' +
      'font-weight:800;letter-spacing:0.5px;'
    );
    badge.textContent = 'AI';

    btn.appendChild(sparkle);
    btn.appendChild(text);
    btn.appendChild(badge);

    // Hover effects
    btn.addEventListener('mouseenter', function() {
      btn.style.background = 'linear-gradient(135deg,#DB2777,#BE185D)';
      btn.style.color = 'white';
      btn.style.transform = 'translateY(-1px)';
      btn.style.boxShadow = '0 4px 15px rgba(219,39,119,0.3)';
      badge.style.background = 'white';
      badge.style.color = '#DB2777';
    });
    btn.addEventListener('mouseleave', function() {
      btn.style.background = 'linear-gradient(135deg,#FDF2F8,#FCE7F3)';
      btn.style.color = '#DB2777';
      btn.style.transform = '';
      btn.style.boxShadow = '';
      badge.style.background = '#DB2777';
      badge.style.color = 'white';
    });

    btn.addEventListener('click', function() {
      openTryOn(product);
    });

    // Find the best insertion point — after Add to Cart button area
    var formActions = document.querySelector('.product-form__buttons, .product-form__submit, [class*="product-form"] button[type="submit"]');
    var addToCartBtn = document.querySelector('button[name="add"], button.product-form__cart-submit, .shopify-payment-button');
    var buyNowBtn = document.querySelector('.shopify-payment-button');

    var insertTarget = buyNowBtn || addToCartBtn || formActions;
    if (insertTarget) {
      // Insert after the buy section
      var container = insertTarget.closest('.product-form__buttons, .product-form, .product__form, form');
      if (container) {
        container.parentNode.insertBefore(btn, container.nextSibling);
      } else {
        insertTarget.parentNode.insertBefore(btn, insertTarget.nextSibling);
      }
    } else {
      // Fallback: insert after main product info
      var productInfo = document.querySelector('.product__info-wrapper, .product-single__meta, [class*="product-info"]');
      if (productInfo) {
        productInfo.appendChild(btn);
      }
    }

    console.log('[Lucy TryOn] Product page button injected for:', product.title);
  }

  // ==========================================
  // PUBLIC API
  // ==========================================
  window.LucyTryOn = {
    open: openTryOn,
    close: closeTryOn,
    isOpen: function() { return state.isOpen; },
    openFromProduct: function() {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
      var img = document.querySelector('meta[property="og:image"]');
      var handle = (location.pathname.indexOf('/products/') >= 0) ? location.pathname.split('/products/')[1].split('?')[0] : '';
      var vid = '';
      try {
        vid = new URLSearchParams(location.search).get('variant') || '';
        if (!vid && meta && meta.variants && meta.variants[0]) vid = meta.variants[0].id;
      } catch (e) {}
      if (img) {
        openTryOn({
          image: img.content,
          title: (meta && meta.type ? meta.type + ' - ' : '') + (document.querySelector('h1') ? document.querySelector('h1').textContent.trim() : ''),
          price: (document.querySelector('.price .money, [class*="price"] .money') || {}).textContent || '',
          type: (meta && meta.type) || '',
          id: (meta && meta.id) || '',
          handle: handle,
          variantId: vid || null,
          url: handle ? '/products/' + handle : ''
        });
      }
    }
  };

  // Init on DOM ready — gated by TRYON_ENABLED server flag.
  function initTryOnWhenEnabled() {
    fetch(TRYON_API + '/config', { credentials: 'omit' })
      .then(function(res) { return res.json(); })
      .then(function(cfg) {
        TRYON_CONFIG.tryon_enabled = !!(cfg && cfg.tryon_enabled);
        if (cfg && cfg.model_display) TRYON_CONFIG.model_display = cfg.model_display;
        if (cfg && cfg.daily_free_limit) TRYON_CONFIG.daily_free_limit = cfg.daily_free_limit;
        TRYON_CONFIG.loaded = true;
        if (!TRYON_CONFIG.tryon_enabled) {
          console.info('[Lucy TryOn] feature gated off (TRYON_ENABLED=false)');
          return;
        }
        // Panel + product-page entry point only built when feature is live.
        createTryOnPanel();
        injectProductPageButton();
        console.log('[Lucy TryOn] Immersive Virtual Try-On v1.8 loaded (' + TRYON_CONFIG.model_display + ')');
      })
      .catch(function(err) {
        console.warn('[Lucy TryOn] config fetch failed — staying gated off:', err);
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTryOnWhenEnabled);
  } else {
    initTryOnWhenEnabled();
  }
})();

